export default {
  TermCondition:[],
}